export enum TabStepRechargeIndexEnum {
  MODE = '1',
  DATA = '2',
  VALUE = '3',
  CONFIRMATION = '4',
  RECEIPT = '5',
}

export enum RechargeType {
  CELLPHONE = 'cellphone',
  DIGITAL = 'digital',
}

export enum CarrierNameEnum {
  ALGAR = 'algar',
  CLARO = 'claro',
  CORREIOS = 'correios',
  EMBRATEL = 'embratel',
  OI = 'oi',
  SERCOMTEL = 'sercomtel',
  TIM = 'tim',
  VIVO = 'vivo',
  UBER = 'uber',
  XBOX = 'xbox',
}

export enum RechargeTypeEnum {
  PHONE = '1',
  DIGITAL = '2',
  COUNTRY_CODE = '55',
}

export enum RechargeExternalTerminalEnum {
  APP = 'APP-01',
  WEB = 'WEB-01',
}

export enum RechargeCategoryEnum {
  CELLPHONE = 1,
  GAMES = 2,
  TV = 3,
  TRANSPORT = 4,
  DIGITAL_CONTENT = 5,
}

export enum RechargeStatusEnum {
  PROCESSING = 0,
  DONE = 1,
  ERROR = 2,
}
